<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة  تقرير شامل فرع  من الي
        <br />
        {{ $route.query.name }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          تقرير  شامل فرع  لـ {{ $route.query.name }} من الي
          {{ $route.query.from }} الي
          {{ $route.query.to }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
             <p>
                <span style="font-weight:bold;">مجموع المبيعات  : </span>
                <span> {{ all_of_total }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع المرتجعات : </span>
                <span> {{ all_of_total2 }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> مجموع المشتريات: </span>
                <span> {{ all_of_total3 }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">مجموع مرتجع المشتريات : </span>
                <span> {{ all_of_total4 }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> مجموع المصروفات: </span>
                <span> {{ all_of_total5 }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> مجموع السدادات: </span>
                <span> {{ all_of_total6 }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">مجموع الخصومات : </span>
                <span> {{ all_of_total7 }} </span>
              </p>
            
        
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;">  عدد المبيعات: </span>
                <span> {{ count_of_count }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> عدد المرتجعات: </span>
                <span> {{ count_of_count2 }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">عدد المشتريات : </span>
                <span> {{ count_of_count3 }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> عدد مرتجع المشتريات: </span>
                <span> {{ count_of_count4 }} </span>
              </p>
        
              <p>
                <span style="font-weight:bold;"> عدد المصروفات: </span>
                <span> {{ count_of_count5 }} </span>
              </p>
             <p>
                <span style="font-weight:bold;">عدد السدادات : </span>
                <span> {{ count_of_count6 }} </span>
              </p>
              <p>
                <span style="font-weight:bold;"> عدد الخصومات: </span>
                <span> {{ count_of_count7 }} </span>
              </p>
        
            
        
            </div>
          </div>
        </div>
        <hr />
        <p>المبيعات</p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع مبيعاته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>مرتجعات المبيعات</p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas2.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع مرتجعاته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas2" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>المشتربات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas3.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود المورد</th>
              <th scope="col">اسم المورد</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع مشترياته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas3" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>مرتجعات المشتربات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas4.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود المورد</th>
              <th scope="col">اسم المورد</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع مرتجعاته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas4" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>المصروفات </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas5.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">كود</th>
              <th scope="col">المصروف</th>
              <th scope="col">نوع المصروف</th>
              <th scope="col">الشخص المسئول</th>
              <th scope="col">تم الصرف لمن؟</th>
              <th scope="col">ملاحظات</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas5" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.money_q }}</td>
              <td>{{ f.money.name }}</td>
              <td>{{ f.emp_responsible_name }}</td>
              <td>{{ f.emp_name_to }}</td>
              <td>{{ f.notes }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>سداد العملاء </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas6.length > 0"
        >
             <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع سداداته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas6" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
        <hr />
        <p>خصومات العملاء </p>
        <table
          class="table table-sm table-bordered"
          style="text-align:center"
          v-if="fatworas7.length > 0"
        >
             <thead>
            <tr>
              <th scope="col">كود العميل</th>
              <th scope="col">اسم العميل</th>
              <th scope="col">عدد الفواتير</th>
              <th scope="col">مجموع خصوماته</th>
            
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatworas7" :key="f.id">
              <th scope="row">{{ f.code }}</th>
              <td>{{ f.name }}</td>
              <td>{{ f.count }}</td>
              <td>{{ f.total }}</td>
             
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BranchSalesReport } from "../../config/apiRoute.js";
import { appUrl } from "../../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatworas: [],
      fatworas2: [],
      fatworas3: [],
      fatworas4: [],
      fatworas5: [],
      fatworas6: [],
      fatworas7: [],
      all_of_total: 0,
      count_of_count: 0,
      all_of_total2: 0,
      count_of_count2: 0,
      all_of_total3: 0,
      count_of_count3: 0,
      all_of_total4: 0,
      count_of_count4: 0,
      all_of_total5: 0,
      count_of_count5: 0,
      all_of_total6: 0,
      count_of_count6: 0,
      all_of_total7: 0,
      count_of_count7: 0,
      appUrl: "" 
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      var frmData = new FormData();
      frmData.append("branch_id", this.$route.query.id);
      frmData.append("date_from", this.$route.query.from);
      frmData.append("date_to", this.$route.query.to);
      BranchSalesReport(frmData).then(response => {
     response.data.myarr.length > 0
          ? (this.fatworas = response.data.myarr)
          : (this.fatworas = []);
        response.data.myarr2.length > 0
          ? (this.fatworas2 = response.data.myarr2)
          : (this.fatworas2 = []);
        response.data.myarr3.length > 0
          ? (this.fatworas3 = response.data.myarr3)
          : (this.fatworas3 = []);
        response.data.myarr4.length > 0
          ? (this.fatworas4 = response.data.myarr4)
          : (this.fatworas4 = []);
        response.data.myarr5.length > 0
          ? (this.fatworas5 = response.data.myarr5)
          : (this.fatworas5 = []);
        response.data.myarr6.length > 0
          ? (this.fatworas6 = response.data.myarr6)
          : (this.fatworas6 = []);
        response.data.myarr7.length > 0
          ? (this.fatworas7 = response.data.myarr7)
          : (this.fatworas7 = []);
        this.all_of_total = response.data.all_of_total;
        this.count_of_count = response.data.count_of_count;
        this.all_of_total2 = response.data.all_of_total2;
        this.count_of_count2 = response.data.count_of_count2;
        this.all_of_total3 = response.data.all_of_total3;
        this.count_of_count3 = response.data.count_of_count3;
        this.all_of_total4 = response.data.all_of_total4;
        this.count_of_count4 = response.data.count_of_count4;
        this.all_of_total5 = response.data.all_of_total5;
        this.count_of_count5 = response.data.count_of_count5;
        this.all_of_total6 = response.data.all_of_total6;
        this.count_of_count6 = response.data.count_of_count6;
        this.all_of_total7 = response.data.all_of_total7;
        this.count_of_count7 = response.data.count_of_count7;
        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
